<template>
  <sweet-modal modal-theme="light" overlay-theme="dark" ref="modal-logging-scan" class="custom-width">
    <h3>MAWB: {{header}}</h3>
    <el-table
      :data="tableData"
      :row-class-name="tableRowClassName"
      style="width: 100%">
      <el-table-column
        type="index"
        width="50">
      </el-table-column>
      <el-table-column
        label="bagRefNo"
        prop="bagRefNo">
      </el-table-column>
      <!-- <el-table-column
        label="hawb"
        prop="hawb">
      </el-table-column> -->
      <el-table-column
          align="center">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="searchHawb"
            size="mini"
            placeholder="Filter HAWB"/>
        </template>
        <template slot-scope="scope">
          {{scope.row.hawb}}
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="Timestamp">
        <template slot-scope="scope">
            {{formatDate(scope.row.createdAt)}}
        </template>
      </el-table-column>
      <el-table-column
          align="center">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="searchStatus"
            size="mini"
            placeholder="Filter status"/>
        </template>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status === 'Passed' ? 'success' : 'danger'"
            disable-transitions>{{scope.row.status}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
  </sweet-modal>
</template>

<script>
export default {
  props: {
    header: '',
    notice: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: []
    },
  },
  data: () => ({
    searchHawb: '',
    searchStatus: '',
  }),
  watch: {
    notice (newVal, oldVal){
      if (newVal) {
        this.$refs['modal-logging-scan'].open()
        this.$emit('afterModalShow')
      }
    },
  },
  computed: {
    tableData () {
      let result = this.value
      if (this.searchHawb) {
        result = result.filter(data => !this.searchHawb || data.hawb.toLowerCase().includes(this.searchHawb.toLowerCase()))
      }

      if (this.searchStatus) {
        result = result.filter(data => !this.searchStatus || data.status.toLowerCase().includes(this.searchStatus.toLowerCase()))
      }

      return result
    }
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (row.status === 'Repeat') {
        return 'warning-row';
      } else if (row.status === 'Passed') {
        return 'success-row';
      }
      return '';
    },
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear(),
          hours = d.getHours(),
          minutes = d.getMinutes(),
          seconds = d.getSeconds()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [day, month, year].join('-') + ' ' +[hours, minutes, seconds].join(':')
    },
  }
}
</script>

<style scoped lang="scss">
  .el-table .warning-row {
    background: #ffc0c0 !important;
  }

  .el-table .success-row {
    background: #f0f9eb !important;
  }
  .custom-width {
    width: 100%;
  }

</style>
